import { ALL_OPTION } from '@/common/constants';
import { Option } from '@/common/types';
import { InvoiceTypeView } from '@/modules/employer/components/ReconciliationReports/components/FinOpsInvoicing/types/invoicing.constants';
import { IInvoiceType } from '@/types';

export const UNPAID_INVOICE_TYPES = [
  IInvoiceType.REPLENISHMENT,
  IInvoiceType.PLAN_LEVEL_REPLENISHMENT,
  IInvoiceType.ORGANIZATION_LEVEL_CONTRIBUTIONS,
  IInvoiceType.PLAN_LEVEL_CONTRIBUTIONS,
  IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT,
  IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT,
  IInvoiceType.EOY_PLAN_RECONCILIATION,
  IInvoiceType.BALANCE_ADJUSTMENT,
];

export const UNPAID_INVOICE_TYPE_OPTIONS: Option[] = [
  ALL_OPTION,
  ...UNPAID_INVOICE_TYPES.map((type) => ({
    key: type,
    value: type,
    title: InvoiceTypeView[type],
  })),
];

export const UNPAID_INVOICES_PAGE_SIZE = 20;

export const FUNDS_HISTORY_PAGE_SIZE = 20;
